import React from 'react';
import PropTypes from 'prop-types';

import i18n from 'i18n-react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import Image from 'components/Image';

import { imgixUrl } from 'settings';

const icons = {
  '': 'align-right',
  autoPlay: 'play',
  Photo: 'images',
};

const Sidebar = (props) => {
  const { appId, items, image } = props;
  const list = items.map((item, i) => {
    const { name, type, active, onClick } = item;
    const key = `sidebar_item_${i}`;
    return (
      // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-noninteractive-element-interactions
      <li onClick={onClick} key={key} className={active ? 'active' : null}>
        {/* <span>{`${`0${i + 1}`.slice(-2)}.`}</span> */}
        <FontAwesomeIcon icon={['fas', icons[type]]} />
        <span>{type === 'autoPlay' ? i18n.translate('nav.media') : name}</span>
      </li>
    );
  });

  let parsedImage = image?.includes('http') ? image : `${imgixUrl}${appId}/${image}?w=300`;
  parsedImage = parsedImage.replace('s3.amazonaws.com/developertool/', 'travprocdn.imgix.net/');
  return (
    <ul className="sidebar">
      <Image src={parsedImage} alt={parsedImage} className="header__image" />
      {list}
    </ul>
  );
};

export default Sidebar;

Sidebar.propTypes = {
  appId: PropTypes.number.isRequired,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      type: PropTypes.oneOf(['', 'autoPlay', 'Photo']),
    }),
  ).isRequired,
  image: PropTypes.string.isRequired,
};
